import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Button } from 'reactstrap';

export default class RemoveTimesheetDetailButton extends React.Component {
    removeDetail = () => {
        const {
            dailyTimesheetDetail,
            dailyTimesheet,
            onDailyTimesheetMutated,
        } = this.props;

        dailyTimesheet.dailyTimesheetDetails =
            dailyTimesheet.dailyTimesheetDetails.filter(
                (dtd) => dtd != dailyTimesheetDetail
            );

        onDailyTimesheetMutated(dailyTimesheet);
    };

    render() {
        const { readOnly, lockedDown } = this.props;

        if (lockedDown) {
            return null;
        }

        return (
            <Button
                type="button"
                color="danger"
                outline={true}
                onClick={this.removeDetail}
                disabled={readOnly}
            >
                <FontAwesomeIcon icon={faTrash} />
            </Button>
        );
    }
}
